import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import { AppInsightsErrorBoundary } from 'AppInsights';
import strings from 'strings';
import ErrorDiagnosticsPanel from 'UI/components/organisms/ErrorDiagnosticsPanel';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import { UIStatus } from 'UI/constants/status';
import { SvgNoSearchProjectsFolders } from 'UI/res';

import { ProgressContainer } from './styles';

const EMPTY_STATE_SIZE = 300;

const ErrorFallback = ({ error }) => {
  return (
    <>
      <Typography variant="h5" gutterBottom>
        {strings.shared.ui.unknownError.title}
      </Typography>
      {error && <ErrorDiagnosticsPanel error={error?.message} />}
    </>
  );
};

const defaultLoading = (
  <ProgressContainer>
    <CircularProgress />
  </ProgressContainer>
);

const defaultError = (
  <EmptyPlaceholder
    title={strings.shared.errors.serverError.title}
    subtitle={strings.shared.errors.serverError.subtitle}
    customEmptyState={<SvgNoSearchProjectsFolders height={EMPTY_STATE_SIZE} />}
  />
);
const defaultEmpty = (
  <EmptyPlaceholder
    title={strings.shared.emptyState.title}
    subtitle={strings.shared.emptyState.subtitle}
  />
);

const StatusManager = ({
  children,
  slots: { Default, Loading, Error, Empty } = {
    Default: null,
    Empty: null,
    Error: null,
    Loading: null
  },
  status = UIStatus.Empty
}) => {
  const statusComponents = {
    [UIStatus.Default]: Default,
    [UIStatus.Empty]: Empty || defaultEmpty,
    [UIStatus.Error]: Error || defaultError,
    [UIStatus.Loading]: Loading || defaultLoading,
    [UIStatus.Success]: children
  };

  return (
    <AppInsightsErrorBoundary onError={ErrorFallback}>
      {status !== '' ? statusComponents[status] || null : children}
    </AppInsightsErrorBoundary>
  );
};

export default StatusManager;
